<template>
  <div class="nd-page">
    <header class="nd-page-header">
      <div>
        <h1 id="title" class="page-title">{{ pageTitle }}</h1>
        <p class="nd-page-kicker">Mantenha os dados do laboratório parceiro atualizados para exames e laudos.</p>
      </div>
    </header>

    <v-card class="nd-section-card">
      <v-form ref="form" v-model="formValid">
        <div class="nd-table-toolbar">
          <div>
            <div class="nd-table-toolbar__title">Dados do laboratório</div>
            <div class="nd-table-toolbar__subtitle">Identificação principal do parceiro.</div>
          </div>
        </div>
        <div class="nd-form-grid">
          <v-text-field
            label="Nome do Laboratório"
            v-model="laboratory.name"
            :rules="[rules.required]"
            outlined
            dense
           hide-details="auto"></v-text-field>
          <v-text-field
            label="CNPJ"
            v-model="laboratory.cnpj"
            outlined
            dense
            placeholder="00.000.000/0000-00"
            @input="maskCnpj"
            maxlength="18"
           hide-details="auto"></v-text-field>
        </div>
        <div class="nd-form-actions">
          <v-btn id="btnBack" type="button" color="primary" outlined elevation="0" @click="$router.push('/laboratorios')">
            Voltar
          </v-btn>
          <v-btn id="btnSave" type="button" color="primary" elevation="0" @click="save" :loading="loadingSave">
            Salvar
          </v-btn>
        </div>
      </v-form>
    </v-card>

    <v-overlay :value="loadingPage">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LaboratoriesDetails",

  data: () => ({
    laboratory: { id: null, name: "", cnpj: "" },
    loadingPage: false,
    loadingSave: false,
    formValid: false,
    rules: {
      required: (value) => !!value || "Campo obrigatório.",
    },
  }),

  computed: {
    pageTitle() {
      return this.laboratory.id ? "Detalhes do Laboratório" : "Novo Laboratório";
    },
    breadcrumbs() {
      return [
        { text: "Home", disabled: false, to: "/home", exact: true },
        { text: "Laboratórios", disabled: false, to: "/laboratorios", exact: true },
        { text: this.laboratory.id ? "Detalhes" : "Novo", disabled: true, exact: true },
      ];
    },
  },

  async created() {
    const id = this.$route.params.id;
    if (id) {
      this.loadingPage = true;
      await this.load(id);
      this.loadingPage = false;
    }
  },

  methods: {
    async load(id) {
      try {
        const response = await axios.get(`/laboratories/${id}`);
        const d = response.data.data;
        this.laboratory = { id: d.id, name: d.name, cnpj: d.cnpj || "" };
      } catch (error) {
        this.$dialog.notify.error("Erro ao carregar laboratório.", { position: "top-right", timeout: 5000 });
      }
    },

    maskCnpj(value) {
      let v = value.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/, "$1.$2");
      v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
      v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
      v = v.replace(/(\d{4})(\d)/, "$1-$2");
      this.laboratory.cnpj = v;
    },

    async save() {
      if (!this.$refs.form.validate()) return;

      this.loadingSave = true;
      try {
        const payload = {
          name: this.laboratory.name,
          cnpj: this.laboratory.cnpj || undefined,
        };

        if (this.laboratory.id) {
          await axios.patch(`/laboratories/${this.laboratory.id}`, payload);
          this.$dialog.notify.success("Laboratório atualizado com sucesso!", { position: "top-right", timeout: 3000 });
        } else {
          await axios.post("/laboratories", payload);
          this.$dialog.notify.success("Laboratório criado com sucesso!", { position: "top-right", timeout: 3000 });
        }
        this.$router.push("/laboratorios");
      } catch (error) {
        this.$dialog.notify.error("Erro ao salvar laboratório.", { position: "top-right", timeout: 5000 });
      } finally {
        this.loadingSave = false;
      }
    },
  },
};
</script>
